module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/othertransaction/pigmy-monthly-transfer/pigmy-monthly-transfer.component.css
// module id = ./src/app/othertransaction/pigmy-monthly-transfer/pigmy-monthly-transfer.component.css
// module chunks = main